/* External */
import {
  useCallback, useMemo, useRef, useEffect,
} from 'react';
import throttle from 'lodash-es/throttle';

/* Utils */

export default function useHandleThrottleArrowPress(handleArrowPress, delay = 40) {
  const delayArrowPress = delay;

  const enableArrowPress = useRef(true);
  const updateEnableArrowPress = useMemo(() => throttle(() => {
    enableArrowPress.current = true;
  }, delayArrowPress, { leading: true, trailing: false }), [delayArrowPress]);

  const handleThrottleArrowPress = useCallback((...args) => {
    enableArrowPress.current = false;
    updateEnableArrowPress();
    if (enableArrowPress.current && handleArrowPress) {
      return handleArrowPress(...args);
    }
    return enableArrowPress.current;
  }, [handleArrowPress, updateEnableArrowPress]);

  useEffect(() => {
    const currentUpdateEnableArrowPress = updateEnableArrowPress;
    return () => {
      currentUpdateEnableArrowPress.cancel();
    };
  }, [updateEnableArrowPress]);

  return handleThrottleArrowPress;
}
